function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import classNames from 'classnames';
import React, { useLayoutEffect, useRef, useEffect } from 'react';
import Target from './Target';
import Accordion from './Accordion';
import { AliasForwardRefWithChain } from '../types';
import { Collapsible } from './utils';
import './index.scss';
const Collapse = AliasForwardRefWithChain(({
  as: Component = 'div',
  eventKey,
  accordionKey,
  transition,
  children,
  className,
  show,
  persistentShow = false,
  onShow,
  onShown,
  onHidden,
  onHide,
  ...props
}, ref) => {
  const targetRef = useRef(null);
  useEffect(() => {
    const target = targetRef.current;
    const collapse = target?.neu?.collapse;

    if (typeof show === 'boolean' && collapse) {
      if (show) {
        collapse.show();
      } else {
        collapse.close();
      }
    }
  }, [show]);
  useLayoutEffect(() => {
    const target = targetRef.current;
    const cleanup = new Collapsible(target);

    if (onShow) {
      target?.addEventListener('show.n.collapse', onShow);
    }

    if (onShown) {
      target?.addEventListener('shown.n.collapse', onShown);
    }

    if (onHide) {
      target?.addEventListener('hide.n.collapse', onHide);
    }

    if (onHidden) {
      target?.addEventListener('hidden.n.collapse', onHidden);
    }

    return () => {
      if (onShow) {
        target?.removeEventListener('show.n.collapse', onShow);
      }

      if (onShown) {
        target?.removeEventListener('shown.n.collapse', onShown);
      }

      if (onHide) {
        target?.removeEventListener('hide.n.collapse', onHide);
      }

      if (onHidden) {
        target?.removeEventListener('hidden.n.collapse', onHidden);
      }

      cleanup.destroy();
    };
  }, []);
  return /*#__PURE__*/React.createElement(Component, _extends({
    ref: node => {
      targetRef.current = node;
      if (ref) ref.current = node;
    },
    className: classNames("collapse", null, transition && `collapse-${transition}`, className)
  }, props, {
    "data-persistent": persistentShow,
    "data-collapsible": eventKey,
    "data-accordion": accordionKey ? accordionKey : undefined
  }), children);
});
Collapse.Target = Target;
Collapse.Accordion = Accordion;
export default Collapse;